module.exports = __webpack_public_path__ + "img/icon-news.bf61e568.svg";